module.exports = __webpack_public_path__ + "static/media/error@3x.98c36bcc.png";